import React, { FunctionComponent as FC, ReactNode, Fragment, useContext, useEffect } from 'react';

import { TabsContext } from './TabsContext';


export interface ITab {
  id: string | number;
  title?: string | ReactNode;
  children?: any;
}

const Tab: FC<ITab> = ({ id, title, children, ...props }: ITab) => {
  const { context } = useContext(TabsContext);

  useEffect(() => {
    context.addTab({ id, title, ...props });
  }, [id]);

  const {
    activeTab: { id: activeTabId },
  } = context;
  if (activeTabId !== id) {
    return null;
  }

  return <Fragment>{children}</Fragment>;
};

export default Tab;
